import nProgress from 'nprogress'
import 'nprogress/nprogress.css'

nProgress.configure({
  easing: 'ease',
  speend: 500,
  showSpinner: false,
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化最小百分比
})

export default nProgress
